import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.dev';
@Injectable()
export class EnvironmentService {
  Environments: any;
  private http: HttpClient;
  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler); 
  }
  LoadEnvironments() {
    this.Environments = environment;
  }
  getEnvironmentsConfiguration() {
   return this.Environments;
  }
}
